import { defineMessages, IntlShape } from "react-intl";

enum NotificationSettingsDealClosingInterval {
  MONTH = "1 month",
  WEEK = "1 week",
  DAY = "1 day",
}

const messages = defineMessages({
  [NotificationSettingsDealClosingInterval.DAY]: {
    id: "notificationSettingsDealClosingInterval.day",
    defaultMessage: "1 day before",
    description: "Notification Settings Deal Closing Interval - day",
  },
  [NotificationSettingsDealClosingInterval.MONTH]: {
    id: "notificationSettingsDealClosingInterval.month",
    defaultMessage: "30 days before",
    description: "Notification Settings Deal Closing Interval - month",
  },
  [NotificationSettingsDealClosingInterval.WEEK]: {
    id: "notificationSettingsDealClosingInterval.week",
    defaultMessage: "7 days before",
    description: "Notification Settings Deal Closing Interval - week",
  },
});

export const getNotificationSettingsDealClosingIntervalDisplayName = (
  intl: IntlShape,
  interval: NotificationSettingsDealClosingInterval
) => intl.formatMessage(messages[interval]);

export default NotificationSettingsDealClosingInterval;
